import type { IUseReactQuery } from "@src/types/AppTypes";
import { useQuery } from "@tanstack/react-query";

const useReactQuery = <T,>({ queryFn: q, args }: IUseReactQuery<T>) => {
  const query = useQuery({
    staleTime: args?.staleTime ?? 300000, // 5 min default stale time
    queryFn: () => q<T>(null, args.additionalArg, args.headers),
    enabled: args?.enabled !== undefined ? args.enabled : true,
    queryKey: [...args.queryKey],
    placeholderData: args.placeholderData,
  });

  return query;
};

export default useReactQuery;
